import React from 'react';
import styled from 'styled-components';

const LoadingContainer = styled.div`
    display: block;
    position: fixed;
    padding-top: 35vh;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(5px);
    background-color: rgba(0, 0, 0, .6);

    @keyframes partone {
        0% { opacity: 0; }
        9% { opacity: 0; }
        10% { opacity: 1; }
        59% { opacity: 1; }
        60% { opacity: 0; }
    }

    @keyframes partonebg {
        0% { opacity: 1; }
        9% { opacity: 1; }
        10% { opacity: 0; }
        59% { opacity: 0; }
        60% { opacity: 1; }
    }

    @keyframes parttwo {
        0% { opacity: 0; }
        19% { opacity: 0; }
        20% { opacity: 1; }
        69% { opacity: 1; }
        70% { opacity: 0; }
    }

    @keyframes parttwobg {
        0% { opacity: 1; }
        19% { opacity: 1; }
        20% { opacity: 0; }
        69% { opacity: 0; }
        70% { opacity: 1; }
    }

    @keyframes partthree {
        0% { opacity: 0; }
        29% { opacity: 0; }
        30% { opacity: 1; }
        79% { opacity: 1; }
        80% { opacity: 0; }
    }

    @keyframes partthreebg {
        0% { opacity: 1; }
        29% { opacity: 1; }
        30% { opacity: 0; }
        79% { opacity: 0; }
        80% { opacity: 1; }
    }

    @keyframes partfour {
        0% { opacity: 0; }
        39% { opacity: 0; }
        40% { opacity: 1; }
        89% { opacity: 1; }
        90% { opacity: 0; }
    }

    @keyframes partfourbg {
        0% { opacity: 1; }
        39% { opacity: 1; }
        40% { opacity: 0; }
        89% { opacity: 0; }
        90% { opacity: 1; }
    }

    @keyframes partfive {
        0% { opacity: 0; }
        49% { opacity: 0; }
        50% { opacity: 1; }
        99% { opacity: 1; }
        100% { opacity: 0; }
    }

    @keyframes partfivebg {
        0% { opacity: 1; }
        49% { opacity: 1; }
        50% { opacity: 0; }
        99% { opacity: 0; }
        100% { opacity: 1; }
    }

    #part-one{
        opacity: 0;
        animation: partone 2s ease-in infinite;
    }

    #part-one-bg{
        opacity: 1;
        animation: partonebg 2s ease-out infinite;
    }

    #part-two{
        opacity: 0;
        animation: parttwo 2s ease-in infinite;
    }

    #part-two-bg{
        opacity: 1;
        animation: parttwobg 2s ease-out infinite;
    }

    #part-three {
        opacity: 0;
        animation: partthree 2s ease-in infinite;
    }

    #part-three-bg {
        opacity: 1;
        animation: partthreebg 2s ease-out infinite;
    }

    #part-four {
        opacity: 0;
        animation: partfour 2s ease-in infinite;
    }

    #part-four-bg {
        opacity: 1;
        animation: partfourbg 2s ease-out infinite;
    }

    #part-five {
        opacity: 0;
        animation: partfive 2s ease-in infinite;
    }

    #part-five-bg {
        opacity: 1;
        animation: partfivebg 2s ease-out infinite;
    }
`

class VBLoadingScreen extends React.Component {
    fixStuckLoading() {
        if(this.props.show_loading) {
            if(!this.props.disable_reload_timeout){
                clearTimeout(this.loadingtimeout);
                this.loadingtimeout = setTimeout(function() {
                    window.location.reload()
                }, 60000);
            }
        } else {
            clearTimeout(this.loadingtimeout);
        }
    }
    
    componentDidUpdate() {
        this.fixStuckLoading()
    }

    componentDidMount() {
        this.fixStuckLoading()
    }

    render() {
        if (this.props.show_loading){
            return <LoadingContainer style={{zIndex: this.props.zIndex}} className={this.props.className}>
                <div className="flex items-center justify-center">
                    <div className="flex items-center absolute" style={{ width: '50%', maxWidth: '250px'}}>
                        <svg className="w-full h-full" style={{filter: `invert(96%) sepia(6%) saturate(438%) hue-rotate(334deg) brightness(95%) contrast(89%)`}} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="483px" height="321px" viewBox="0 0 483 321" enableBackground="new 0 0 483 321" space="preserve">
                            <path id="part-four-bg" d="M282.677,163.979L387.354,59.134l58.187,58.581L340.863,222.562h-25.194v-5.408c-23.532,0-44.31-11.355-57.293-28.834L282.677,163.979z"/>
                            <path id="part-one-bg" d="M141.656,222.391H20.783v82.615h134.969c45.59,0,82.482-36.951,82.482-82.615H166.85H141.656L141.656,222.391z"/>
                            <path id="part-five-bg" d="M341.313,222.395h120.873v82.613H327.215c-45.59,0-82.48-36.951-82.48-82.613h71.384H341.313z"/>
                            <path id="part-two-bg" d="M200.636,163.875L95.96,59.029L37.773,117.61L142.45,222.457h25.194v-5.408c23.531,0,44.31-11.355,57.293-28.834L200.636,163.875z"/>
                            <path id="part-three-bg" d="M283.031,163.973V15.868H200.55v148.104l24.301,24.34c8.86-11.926,14.09-26.703,14.09-42.667h5.399c0,16.106,5.293,30.924,14.213,42.842L283.031,163.973z"/>
                        </svg>
                    </div>

                    <div className="flex items-center" style={{zIndex: '1110', width: '50%', maxWidth: '250px'}}>
                        <svg className="supp-forest-green-filter w-full h-full" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="483px" height="321px" viewBox="0 0 483 321" enable-background="new 0 0 483 321" space="preserve">
                            <path id="part-four" d="M282.677,163.979L387.354,59.134l58.187,58.581L340.863,222.562h-25.194v-5.408c-23.532,0-44.31-11.355-57.293-28.834L282.677,163.979z"/>
                            <path id="part-one" d="M141.656,222.391H20.783v82.615h134.969c45.59,0,82.482-36.951,82.482-82.615H166.85H141.656L141.656,222.391z"/>
                            <path id="part-five" d="M341.313,222.395h120.873v82.613H327.215c-45.59,0-82.48-36.951-82.48-82.613h71.384H341.313z"/>
                            <path id="part-two" d="M200.636,163.875L95.96,59.029L37.773,117.61L142.45,222.457h25.194v-5.408c23.531,0,44.31-11.355,57.293-28.834L200.636,163.875z"/>
                            <path id="part-three" d="M283.031,163.973V15.868H200.55v148.104l24.301,24.34c8.86-11.926,14.09-26.703,14.09-42.667h5.399c0,16.106,5.293,30.924,14.213,42.842L283.031,163.973z"/>
                        </svg>
                    </div>
                </div>
                
                <div className="text-center">
                    <span className='white font-bold'>{this.props.loading_text}</span>
                </div>
            </LoadingContainer>
        } else {
            return null;
        }
    }
}

VBLoadingScreen.defaultProps = {
    className: '',
    zIndex: 1090
};

export default VBLoadingScreen;